export default __webpack_public_path__ + "static/media/o12.9364ab47.jpg";